var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "help __pointer",
      on: { mouseenter: _vm.showHelp, mouseleave: _vm.hideHelp }
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowHelp,
              expression: "isShowHelp"
            }
          ],
          staticClass: "help-text"
        },
        [_vm._v(_vm._s(_vm.helpText))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }